var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyVideosAboutYourBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 121,
    viewBox: "0 0 140 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8584 59.4687L131.327 2.47754",
    stroke: "#A7B0BE",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    strokeDasharray: "8 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7168 104.07L64.4248 66.9023",
    stroke: "#A7B0BE",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    strokeDasharray: "8 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4248 115.222V65.6641",
    stroke: "#A7B0BE",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    strokeDasharray: "8 7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.708 69.3802L128.85 74.3359",
    stroke: "#A7B0BE",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    strokeDasharray: "8 7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.584 19.8233L64.4247 69.3809",
    stroke: "#A7B0BE",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    strokeDasharray: "8 7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8055,
    cy: 67.5219,
    r: 8.0531,
    fill: "#A7B0BE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9647,
    cy: 19.2035,
    r: 8.0531,
    fill: "#A7B0BE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.947,
    cy: 73.7172,
    r: 8.0531,
    fill: "#A7B0BE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.001,
    cy: 5.10681,
    r: 5.10681,
    fill: "#A7B0BE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.10681,
    cy: 101.744,
    r: 5.10681,
    fill: "#A7B0BE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.576,
    cy: 115.372,
    r: 5.10681,
    fill: "#A7B0BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVideosAboutYourBrand);
export default __webpack_public_path__ + "static/media/empty-videos-about-your-brand.85d74a2f516bea56321298632c32f4f6.svg";
export { ForwardRef as ReactComponent };